import { JSX } from "react";

import { IconProps } from "@/@types/general.ts";

interface IconPencil extends IconProps {
  variant?: 0 | 1;
}

const IconPencil = ({ variant, ...otherProps }: IconPencil): JSX.Element => {
  const variants: Record<number, JSX.Element> = {
    0: (
      <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 13 12" {...otherProps}>
        <path d="M1.5874 9.23105L9.01106 1.80663L10.6904 3.48616L3.26676 10.9106L1.5874 9.23105Z" />
        <path d="M2.64193 11.2792L1.22065 9.85799L0.523434 11.5856C0.454415 11.7566 0.556619 11.8775 0.58957 11.9104C0.622544 11.9434 0.74331 12.0456 0.914369 11.9766L2.64193 11.2792Z" />
        <path d="M11.3719 0.143759C11.1802 -0.0479197 10.8683 -0.0479197 10.6766 0.143759L9.51165 1.30883L11.1914 2.98854L12.3562 1.82356C12.5479 1.63186 12.5479 1.31994 12.3562 1.12822L11.3719 0.143759Z" />
      </svg>
    ),
    1: (
      <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 17 17" fill="none" {...otherProps}>
        <path
          d="M1.80957 14.4794L5.50908 13.0565C5.74571 12.9655 5.86402 12.92 5.97472 12.8605C6.07304 12.8078 6.16677 12.7469 6.25493 12.6784C6.35418 12.6014 6.44382 12.5118 6.62309 12.3325L14.1429 4.8127C14.8793 4.07632 14.8793 2.88242 14.1429 2.14603C13.4065 1.40966 12.2126 1.40965 11.4763 2.14603L3.95643 9.66585C3.77715 9.84512 3.68752 9.93475 3.6105 10.034C3.54209 10.1222 3.48117 10.2159 3.42839 10.3142C3.36897 10.4249 3.32347 10.5432 3.23246 10.7799L1.80957 14.4794ZM1.80957 14.4794L3.18165 10.912C3.27983 10.6567 3.32893 10.5291 3.41313 10.4706C3.48672 10.4195 3.57777 10.4002 3.66577 10.417C3.76646 10.4362 3.86316 10.5329 4.05656 10.7263L5.56262 12.2324C5.75602 12.4258 5.85272 12.5225 5.87195 12.6232C5.88875 12.7112 5.86943 12.8022 5.81833 12.8758C5.75987 12.96 5.63223 13.0091 5.37695 13.1073L1.80957 14.4794Z"
          strokeWidth="1.33333"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </svg>
    ),
  };
  return variants[variant || 0] ?? variants[0];
};

export default IconPencil;
